<template>
  <div class="profile-wrapper">
    <div class="spinner-container" v-if="isLoading">
      <base-spinner :is-loading="true" :is-local="true" class="spinner" />
    </div>
    <Lender
      v-if="!isLoading && profile.role === 'lender'"
      @createOffer="getLenderOffersList()"
    />
    <Borrower
      v-if="!isLoading && profile.role === 'borrower'"
      @successPayment="updateLoansList()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseSpinner from "../components/base/BaseSpinner.vue";
import Lender from "./Profile/Lender.vue";
import Borrower from "./Profile/Borrower.vue";

export default {
  name: "Profile",
  inject: [
    '$httpService'
  ],
  components: {
    BaseSpinner,
    Lender,
    Borrower
  },
  async created() {
    await this.$store.dispatch('updateProfile');
    await this.$store.dispatch("getLoansList", {...this.params});
    
    if (this.profile.role === 'lender') {
      await this.$store.dispatch('getLenderOffersList', {...this.params});
    }

    this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      params: {
        page: 0,
        size: 10
      }
    };
  },
  methods: {
    async getLenderOffersList() {
      this.isLoading = true;
      await this.$store.dispatch('getLenderOffersList', {size: 10, page: 0});
      this.isLoading = false;
    },
    async updateLoansList() {
      this.isLoading = true;
      await this.$store.dispatch("getLoansList", {...this.params});
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters(["profile"])
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  @include page-wrapper-with-header-and-footer;

  padding-top: 20px;
  box-sizing: border-box;
  background-color: var(--profile-page-bgc);
}

.profile-container {
  @include base-page-container;

  color: #121212;
}

.spinner-container {
  @include base-page-container;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
  color: var(--profile-text-color);
}

.company-info {
  display: flex;
}

.company-name {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: 32px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: #000000;
}

.rate-block {
  margin-left: 25px;
  display: flex;
  align-items: center;

  span {
    margin-top: 3px;
    margin-left: 4px;
    margin-right: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: var(--profile-rate-text-color);
  }
}

.rate {
  font-weight: 600;
  font-size: 24px;
  line-height: 130%;
  color: #41BF7B;
}

.spinner ::v-deep {
  width: 100%;
}
</style>
